import { render, staticRenderFns } from "./ToggleSwitchComponent.vue?vue&type=template&id=31748e22"
import script from "./ToggleSwitchComponent.vue?vue&type=script&lang=ts"
export * from "./ToggleSwitchComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports